import update from "immutability-helper";
import * as CreDtos from "../CRE.dtos";

import {
    ABOUTUSSETTINGS_REQUEST,
    ABOUTUSSETTINGS_REQUEST_SUCCESS,
    ABOUTUSSETTINGS_REQUEST_FAILURE,
    ABOUTUSSETTINGS_REQUEST_UPSERT_REQUEST,
    ABOUTUSSETTINGS_REQUEST_UPSERT_REQUEST_FAILURE,
    ABOUTUSSETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS
} from "../actions/aboutUsSettings.actions";

const initialState = {
    aboutUsSettings: {},
    isLoading: true,
    isSaving: false
};

function loading(state, isLoading) {
    let newState = update(state, {
        isLoading: { $set: isLoading }
    });
    return newState;
}

function saving(state, isSaving) {
    let newState = update(state, {
        isSaving: { $set: isSaving }
    });
    return newState;
}

function setAboutUsSettings(state, aboutUsSettings) {
    let newState = update(state, {
        aboutUsSettings: { $set: aboutUsSettings }
    });
    return newState;
}

export default function people(state = initialState, action) {
    switch (action.type) {
        case ABOUTUSSETTINGS_REQUEST:
            return loading(state, true);
        case ABOUTUSSETTINGS_REQUEST_SUCCESS:
            return setAboutUsSettings(loading(state, false), action.aboutUsSettings);
        case ABOUTUSSETTINGS_REQUEST_FAILURE:
            return loading(state, false);
        
        case ABOUTUSSETTINGS_REQUEST_UPSERT_REQUEST:
            return saving(state, true);
        case ABOUTUSSETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS:
            return saving(setAboutUsSettings(state, action.aboutUsSettings), false);
        case ABOUTUSSETTINGS_REQUEST_UPSERT_REQUEST_FAILURE:
            return saving(state, false);
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/aboutUsSettings.ts